import { useQuery } from '@apollo/client';
import {
  GetOrganizationUsers,
  OrganizationPersonOrder
} from '../../../Apollo';
import useNotification from 'Hooks/useNotification';
import OrganizationUsersTable from './OrganizationUsersTable';
import useTableUserSettings from 'Hooks/useTableUserSettings';

interface Props {
  organizationCode: string;
}

function OrganizationUsersTableContainer(props: Readonly<Props>) {
  const { organizationCode } = props;
  const { onError } = useNotification();

  const {
    selectedIds,
    currentPage,
    rowsPerPage,
    orderBy,
    personFilter,
    handleSearch,
    onChangeRowsPerPage,
    onChangeOrderBy,
    onChangePage,
    handleSelect,
    handleUnselect,
    setSelectedIds
  } = useTableUserSettings(organizationCode, OrganizationPersonOrder.NameAsc);

  const handleRefetch = () => {
    refetch();
    setSelectedIds([]);
  };

  const variables = {
    filter: {
      organizationCode,
      contactDetails: personFilter ?? null
    },
    offset: currentPage * rowsPerPage,
    first: rowsPerPage,
    orderBy
  };

  const { data, loading: fetching, refetch } = useQuery<
    GetOrganizationUsersData
  >(GetOrganizationUsers, {
    onError,
    variables
  });

  let loading = fetching;
  let rows: { node: IOrganizationPerson }[] = [];
  let totalCount = rowsPerPage;

  if (data?.usersOfOrganization) {
    rows = data.usersOfOrganization.edges;
    totalCount = data.usersOfOrganization.totalCount;
  } else {
    loading = true;
  }

  const selectedCount = selectedIds == null ? totalCount : selectedIds.length;

  return (
    <OrganizationUsersTable
      rows={rows}
      loading={loading}
      selectedCount={selectedCount}
      selectedIds={selectedIds}
      filter={personFilter}
      totalCount={totalCount}
      orderBy={orderBy}
      rowsPerPage={rowsPerPage}
      currentPage={currentPage}
      onSearch={handleSearch}
      onChangeOrderBy={onChangeOrderBy}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onSelect={handleSelect}
      onUnselect={handleUnselect}
      onChangePage={onChangePage}
      onReloadUsers={handleRefetch}
      organizationCode={organizationCode}
    />
  );
}

export default OrganizationUsersTableContainer;
